import type { ActivityEntryDto, ProposalDeadlineRadarItem } from "@tc/shared";

const API_URL = import.meta.env.VITE_API_URL ?? "/api";

/** Cross-club operations data (TW-3440/3446). Plain fetch, mirroring features/trips/api.ts. */
export const opsApi = {
  /** Recent cross-club lifecycle activity for the operations dashboard (back office only). */
  activity: async (): Promise<ActivityEntryDto[]> => {
    const res = await fetch(`${API_URL}/activity`, { headers: { accept: "application/json" } });
    if (!res.ok) throw new Error(`Request failed (${res.status})`);
    return (await res.json()) as ActivityEntryDto[];
  },

  /**
   * Cross-club pending proposal deadlines for the deadline radar (TW-3446, back office only).
   * Optionally scoped to one club by the topbar switcher (`?clubId=`).
   */
  deadlineRadar: async (clubId?: string): Promise<ProposalDeadlineRadarItem[]> => {
    const qs = clubId ? `?clubId=${encodeURIComponent(clubId)}` : "";
    const res = await fetch(`${API_URL}/proposals/deadline-radar${qs}`, {
      headers: { accept: "application/json" },
    });
    if (!res.ok) throw new Error(`Request failed (${res.status})`);
    return (await res.json()) as ProposalDeadlineRadarItem[];
  },
};
